import styled from "styled-components";
import { Field } from "@zendeskgarden/react-forms";

export const MediaInputWrapper = styled.div`
  input[data-garden-id="forms.media_input"] {
    padding-left: 0.5rem;
  }
`;

export const InputContainer = styled(Field)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
